import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addLocation = async (data) => {
  await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/locationCreation`,
    data,
  );
};

export const updateLocation = async (data) => {
  await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/locationCreation`,
    data,
  );
};

export const getLocation = async (id) => {
  const response = await gatewayInstance.get(
    `${SERVICE_ENDPOINT.TRANSPORT}/locationCreation/${id}`,
  );
  return response.data;
};

export const searchLocation = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/location/search`,
    data,
  );
  return response.data;
};